import { useNavigate } from "react-router-dom";

import { Card, CardContent } from "@/components/ui/card";
import { TwoFactorEnrollment } from "@/components/features/security/two-factor-enrollment";

/**
 * Where a professional configures their authenticator deliberately — from a
 * link, a bookmark, or the apiClient's redirect on the enrollment code.
 *
 * The flow itself lives in TwoFactorEnrollment, shared with the blocking gate
 * that covers the app when enrollment is mandatory. This page is its frame:
 * a card on a normal route someone can arrive at and leave.
 *
 * Spec 5d9018f9, control C-5.
 */
export function TwoFactorSetupPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-xl p-6">
      <Card>
        <CardContent className="p-6">
          <TwoFactorEnrollment onDone={() => navigate("/", { replace: true })} />
        </CardContent>
      </Card>
    </div>
  );
}

export default TwoFactorSetupPage;
